export const generateInitialPolygons = (svgData, width, height) => {
    const initPolygons = {}
    svgData.forEach(target => {
        let points = []
        for (let i = 0; i < target.middle.length; i = i + 1) {
            points.push(`${target.start[0] / 10 * width / 100} ${target.start[1] / 10 * height / 100}`)
        }
        initPolygons[target.id] = points.join(' ')
    })
    return initPolygons
}

export const calcComponentState = (componentName, navState) => {
    if (navState.activeComponent === componentName) {
        return 'ACTIVE'
    } else if (navState.preLoadingComponent === componentName) {
        return 'PRELOADING'
    } else if (navState.animatingInComponent === componentName) {
        return 'ANIMATING_IN'
    } else if (navState.animatingOutComponent === componentName) {
        return 'ANIMATING_OUT'
    } else if (navState.animatingOutStagedComponent === componentName) {
        return 'ANIMATING_OUT_STAGED'
    }
    return 'OFF'
}
